/**
 * Sport Bundle Add-to-Cart
 * Adds a bundle product to the cart from the Sportilla syksyyn landing page.
 * Each bundle has separate sizes for boxers and shirt (25 variants), shown as
 * two selects. The variant ID is looked up from a "size1|size2" map rendered
 * into the card as JSON. No size is preselected — the button stays disabled
 * until BOTH are chosen, matching the size-gate behaviour on product pages.
 * Follows the established IIFE + polling pattern (see multipack-quick-add.js).
 */
(function() {
  'use strict';

  var SUCCESS_DURATION = 2000;
  var ERROR_DURATION = 5000;

  function initButton(button) {
    if (button.dataset.sportBundleInit === 'true') return;
    button.dataset.sportBundleInit = 'true';

    var textEl = button.querySelector('[data-sport-bundle-text]');
    var loadingEl = button.querySelector('.sport-bundle-card__loading');
    var successEl = button.querySelector('.sport-bundle-card__success');
    var errorEl = button.parentElement.querySelector('.sport-bundle-card__error');
    var card = button.closest('.sport-bundle-card');
    var sel1 = card ? card.querySelector('[data-sport-bundle-opt="1"]') : null;
    var sel2 = card ? card.querySelector('[data-sport-bundle-opt="2"]') : null;
    var mapEl = card ? card.querySelector('[data-sport-bundle-variants]') : null;

    if (!textEl || !loadingEl || !successEl || !sel1 || !mapEl) return;

    // "koko1:koko2=id|koko1:koko2=id|" — ei JSONia, ks. sectionin kommentti
    var variantMap = {};
    mapEl.getAttribute('data-sport-bundle-variants').split('|').forEach(function(pair) {
      if (!pair) return;
      var eq = pair.lastIndexOf('=');
      if (eq === -1) return;
      variantMap[pair.slice(0, eq)] = pair.slice(eq + 1);
    });

    // Look up the variant for the current pair of selections.
    // sel2 is absent on single-option products, hence the empty-string fallback.
    function currentVariantId() {
      var a = sel1.value;
      var b = sel2 ? sel2.value : '';
      if (!a || (sel2 && !b)) return null;
      return variantMap[a + ':' + b] || null;
    }

    function syncEnabled() {
      button.disabled = !currentVariantId();
    }

    /**
     * Greys out the sizes in `target` that have no available variant against
     * the size currently chosen in `source`.
     *
     * Sizes sold out in every combination are already disabled server-side.
     * This handles the narrower case: a size that exists, but not together
     * with what the customer just picked. Without it the second select still
     * offers those sizes and the button silently stays dead, which reads as a
     * broken button rather than as a sold-out size.
     */
    function filterOptions(source, target, sourceIsFirst) {
      if (!source || !target) return;
      var chosen = source.value;

      Array.prototype.forEach.call(target.options, function(option) {
        if (!option.value) return; // leave the "Valitse" placeholder alone

        var soldOutEverywhere = option.dataset.soldOut === 'true';
        if (soldOutEverywhere) return; // already disabled by Liquid

        if (!chosen) {
          option.disabled = false;
          return;
        }

        var key = sourceIsFirst ? chosen + ':' + option.value : option.value + ':' + chosen;
        option.disabled = !variantMap[key];
      });

      // If the current selection just became unavailable, clear it rather than
      // leaving a disabled option showing as chosen.
      if (target.selectedOptions[0] && target.selectedOptions[0].disabled) {
        target.value = '';
      }
    }

    function syncAll() {
      filterOptions(sel1, sel2, true);
      filterOptions(sel2, sel1, false);
      syncEnabled();
    }

    // Remember which options Liquid disabled, so filtering never re-enables them.
    [sel1, sel2].forEach(function(sel) {
      if (!sel) return;
      Array.prototype.forEach.call(sel.options, function(option) {
        if (option.disabled && option.value) option.dataset.soldOut = 'true';
      });
    });

    sel1.addEventListener('change', syncAll);
    if (sel2) sel2.addEventListener('change', syncAll);
    syncAll();

    function setState(state) {
      textEl.hidden = state !== 'default';
      loadingEl.hidden = state !== 'loading';
      successEl.hidden = state !== 'success';
      button.disabled = state === 'loading' || state === 'success';
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
      setTimeout(function() {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }, ERROR_DURATION);
    }

    button.addEventListener('click', function() {
      var variantId = currentVariantId();
      if (!variantId) {
        showError('Valitse ensin molemmat koot.');
        return;
      }

      setState('loading');

      // Collect section IDs for cart drawer morph (matches product-form.js pattern)
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function(el) {
        if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: sectionIds.join(',')
        })
      })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(data) {
              throw new Error(data.description || data.message || 'Tuntematon virhe');
            });
          }
          return response.json();
        })
        .then(function(data) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            detail: {
              resource: data,
              data: { sections: data.sections || {} }
            }
          }));
          setState('success');
          setTimeout(function() {
            setState('default');
            // syncAll, not syncEnabled: the add may have exhausted the last
            // unit, so the option lists need re-filtering too.
            syncAll();
          }, SUCCESS_DURATION);
        })
        .catch(function(err) {
          setState('default');
          syncAll();
          if (err.message && err.message !== 'Failed to fetch') {
            showError(err.message);
          } else {
            showError('Yhteysvirhe. Yritä uudelleen.');
          }
        });
    });
  }

  function checkForButtons() {
    document.querySelectorAll('[data-sport-bundle-add]').forEach(function(btn) {
      if (btn.dataset.sportBundleInit !== 'true') {
        initButton(btn);
      }
    });
  }

  function startPolling() {
    var attempts = 0;
    var maxAttempts = 20;

    function poll() {
      checkForButtons();
      attempts++;
      if (attempts < maxAttempts) {
        setTimeout(poll, 250);
      }
    }

    poll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPolling);
  } else {
    startPolling();
  }

  // Re-init after cart morph resets data attributes
  document.addEventListener('cart:update', function() {
    setTimeout(checkForButtons, 100);
  });
})();
